import { useState } from "react";
import { Sparkles } from "lucide-react";
import { AgenteProvider } from "@/components/agente/AgenteContext";
import { AgenteChat } from "@/components/agente/AgenteChat";

export const ClientAgente = ({ sid, advisorName }) => {
  useState(() => { if (sid) localStorage.setItem("fiin_sid", sid); return true; });
  if (!sid) return null;
  return (
    <section className="card-warm p-5" data-testid="client-agente">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div><h3 className="font-display font-bold flex items-center gap-2"><Sparkles size={16} className="text-[#FF7A00]" /> Agente Fiin · tu asistente 24/7</h3><p className="text-xs text-[#575757] mt-1">Recuerda tu conversación y conoce el avance real de tu solicitud: pregúntale qué te falta, qué sigue o cualquier duda. Lo que no pueda resolver lo confirma {advisorName ? advisorName.split(" ")[0] : "tu asesor"}.</p></div>
      </div>
      <div className="rounded-2xl overflow-hidden border border-black/5 h-[480px]"><AgenteProvider><AgenteChat variant="embedded" /></AgenteProvider></div>
    </section>
  );
};
